import(/* webpackMode: "eager" */ "/codebuild/output/src1497620650/src/basic-traning-frontend/app/error.tsx");
